module.exports = __webpack_public_path__ + "static/media/BTC.0551f63d.svg";